import React from 'react';
import getRoutes from "./routes";
import { useRoutes } from 'react-router-dom';
import {useSelector} from "react-redux";

const Routing = () => {
    const {user} = useSelector(state => state.auth);
    const routing = useRoutes(getRoutes(user));

    return<>
        {routing}
    </>
}


export default Routing;